const contentSliders = document.querySelectorAll('.content-slider.swiper-slider');

contentSliders.forEach((contentSlider) => {
    const swiper = new Swiper(contentSlider,  {
        loop: true,
        autoplay: {
            delay: 5000,
        },
        centeredSlides: true,
        cssMode: true,
        slidePerView: 1,
        navigation: {
            prevEl: contentSlider.querySelector('.swiper-button-prev'),
            nextEl: contentSlider.querySelector('.swiper-button-next'),
        },
    });
});
